import React from 'react';
import { useSelector } from 'react-redux';

import { getLessonMeta } from 'common.components/lesson/selectors';
import { SpecCourseLessonViewRules } from 'common.components/spec-course-lesson-view/__rules/spec-course-lesson-view__rules';

interface Props {
    specialRules?: React.ReactNode | Array<React.ReactNode>;
}

export const SpecCourseLessonViewRulesContainer = (props: Props) => {
    const lessonMeta = useSelector(getLessonMeta);
    const rulesText = (lessonMeta && lessonMeta.rules) || '';

    return <SpecCourseLessonViewRules shouldShowTitle={false} text={rulesText} {...props} />;
};
